import { Link, Navigate } from 'react-router';
import { APP_NAME } from '@sellit/shared';
import { useMe } from './auth';

/** Sellers with one sale go straight to it. */
export function AdminHome() {
  const { sales, user } = useMe();
  // Platform admins manage everything from the platform dashboard.
  if (user.role === 'PLATFORM_ADMIN') return <Navigate to="/platform-admin" replace />;
  if (sales.length === 1) return <Navigate to={`/admin/sales/${sales[0]!.id}`} replace />;
  return (
    <main className="page narrow">
      <h1>Your sales</h1>
      {sales.length === 0 ? (
        <p className="muted">
          Hi {user.displayName}. You don't have a sale yet. Ask your {APP_NAME} contact to set one up.
        </p>
      ) : (
        <ul className="list">
          {sales.map((s) => (
            <li key={s.id}>
              <Link className="row-link" to={`/admin/sales/${s.id}`}>
                <strong>{s.title}</strong>
                <span className="muted">/{s.slug}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </main>
  );
}
